import type { JSX, ReactNode } from 'react'

// Shared by the home page's mock-ups (a server component) and the CareerGPT mock (a client island),
// so it must stay a plain module: a `'use client'` one would hand the server a reference, not a string.

/** The question bubble in every chat mock-up. */
export const BUBBLE = 'ml-auto max-w-[82%] rounded-lg bg-fill-subtle px-[14px] py-[12px] text-xs text-ink'

/** A mock-up's footer strip. */
export function MockFoot({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="flex min-h-[44px] flex-wrap items-center gap-[8px] border-t border-border bg-surface-chrome px-[18px] py-[10px] text-3xs text-ink-secondary">
      {children}
    </div>
  )
}
